module.exports = __webpack_public_path__ + "img/trophy.0bb56514.png";